import React__default, { useRef, useCallback } from 'react';
import { S as SelectListContext } from './SelectListContext-D8hyna51.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';

const selectOptionQuery = 'button[role="option"]:not([disabled])';
const handleKeyDownEvents = (event, context) => {
  if (context) {
    const {
      key,
      target
    } = event;
    if ([KEYBOARD_KEYNAMES.ARROW_DOWN, KEYBOARD_KEYNAMES.ARROW_UP, KEYBOARD_KEYNAMES.HOME, KEYBOARD_KEYNAMES.END].some(k => k === key)) {
      const selectOptionElements = Array.from(context.querySelectorAll(selectOptionQuery));
      const currentIndex = selectOptionElements.indexOf(target);
      if (currentIndex >= 0) {
        var _keys$ARROW_DOWN$keys;
        const newFocusIndex = (_keys$ARROW_DOWN$keys = {
          [KEYBOARD_KEYNAMES.ARROW_DOWN]: Math.min(currentIndex + 1, selectOptionElements.length - 1),
          [KEYBOARD_KEYNAMES.ARROW_UP]: Math.max(currentIndex - 1, 0),
          [KEYBOARD_KEYNAMES.HOME]: 0,
          [KEYBOARD_KEYNAMES.END]: selectOptionElements.length - 1
        }[key]) !== null && _keys$ARROW_DOWN$keys !== void 0 ? _keys$ARROW_DOWN$keys : currentIndex;
        if (currentIndex !== newFocusIndex) {
          event.preventDefault();
          selectOptionElements[newFocusIndex].focus();
        }
      }
    }
  }
};
const SelectList = ({
  mobileFullScreen = false,
  multiple = false,
  onChange,
  selectedValue,
  noWrap = false,
  afterOnSelect,
  children,
  taktId,
  taktValue
}) => {
  const presentationRef = useRef(null);
  const handleKeydown = useCallback(event => {
    handleKeyDownEvents(event, presentationRef.current);
  }, []);
  const handleClick = useCallback((value, event) => {
    onChange === null || onChange === void 0 || onChange(value, event);
  }, [onChange]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('select-list')
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: presentationRef,
    role: "presentation",
    onKeyDown: handleKeydown
  }, /*#__PURE__*/React__default.createElement(SelectListContext.Provider, {
    value: {
      noWrap,
      onClick: handleClick,
      selectedValue,
      afterOnSelect,
      multiple,
      mobileFullScreen
    }
  }, children)));
};

export { SelectList as S, selectOptionQuery as s };
//# sourceMappingURL=SelectList-RSkg79Qn.js.map
